export default __webpack_public_path__ + "static/media/back-btn.19959d33.svg";